import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { OldSolutionsSection } from '../components/OldSolutionsSection';
import { ProductReveal } from '../components/ProductReveal';
import { RitualSection } from '../components/RitualSection';
import { ForYouSection } from '../components/ForYouSection';
import { IncludesSection } from '../components/IncludesSection';
import { PricingSection } from '../components/PricingSection';
import { FooterLegal } from '../components/FooterLegal';
export function SalesPage() {
  return <main className="bg-[#0c1220] min-h-screen text-[#f0e6d3] overflow-x-hidden" data-id="element-198">
      <HeroSection data-id="element-199" />
      <ProblemSection data-id="element-200" />
      <OldSolutionsSection data-id="element-201" />
      <ProductReveal data-id="element-202" />
      <RitualSection data-id="element-203" />
      <ForYouSection data-id="element-204" />
      <IncludesSection data-id="element-205" />
      <PricingSection data-id="element-206" />
      <FooterLegal data-id="element-207" />
    </main>;
}